import { Injectable } from '@angular/core';
import { Router } from '@angular/router';
import { AuthentificationService } from './authentification.service';

@Injectable({ providedIn: 'root' })
export class RolesService {

    roles: string[];
    static readonly gestionnaire = 'GESTIONNAIRE';
    static readonly enquete = 'ENQUETE';
    static readonly consultation = 'CONSULTATION';

    constructor(private auth: AuthentificationService, private router: Router) {
        if (this.auth.isUtilisateurAuthentifie()) {
            this.redirectWithRoles();
        }
    }

    public userRoles: string[] | null;

    public areRolesCharges(): boolean {
        return this.userRoles !== null;
    }

    public isHabilite(rolesHabilites: string[]): boolean {
        // On regarde si l'intersection entre les rôles habilités et les rôles de l'utilisateur contient bien au moins un élément.
        // Implémentation de l'intersection :
        // https://stackoverflow.com/questions/1885557/simplest-code-for-array-intersection-in-javascript#comment77733737_1885569
        const rolesUtilisateur: string[] = this.auth.getUserRoles();
        let intersection: string[] = [];
        if (rolesUtilisateur) {
            intersection = rolesUtilisateur.filter(role => rolesHabilites.includes(role.toLowerCase()));
        }
        return intersection.length > 0;
    }

    private redirectWithRoles(): void {
        this.roles = this.auth.getUserRoles();
        if (this.roles !== null) {
            if (this.roles.lastIndexOf(RolesService.gestionnaire) > -1) { // GESTIONNAIRE
                this.router.navigate(['/saisie']);
            } else if (this.roles.lastIndexOf(RolesService.enquete) > -1) { // ENQUETE
                this.router.navigate(['/saisie']);
            } else { //  EXTERNE
                this.router.navigate(['/acces-interdit']);
            }
        } else {
            this.router.navigate(['/acces-interdit']);
        }
    }

}
